export interface IPriceDetails {
  rowPriceInVat: number;
  unitPrice: number;
  packSize: number;
}

export default class PriceHelper {
  static getPriceDetails = (basketRow: Element): IPriceDetails => {
    const rowPriceElement: HTMLElement = basketRow.querySelector('[data-rowpriceincvat]') as HTMLElement;
    const unitPriceElement: HTMLElement = basketRow.querySelector('[data-unitprice]') as HTMLElement;
    const packSizeElement: HTMLElement = basketRow.querySelector('[data-packsize]') as HTMLElement;

    const rowPriceInVat: string | null = rowPriceElement?.getAttribute('data-rowpriceincvat');
    const unitPrice: string | null = unitPriceElement?.getAttribute('data-unitprice');
    const packSize: string | null = packSizeElement?.getAttribute('data-packsize');

    const rp: number = this.parseCurrencyToFloat(rowPriceInVat);
    const up: number = this.parseCurrencyToFloat(unitPrice);
    const ps: number = this.parseCurrencyToFloat(packSize);

    return {
      rowPriceInVat: rp,
      unitPrice: up,
      packSize: ps,
    };
  };

  static calculateNewRowPriceInVat(basketRow: Element, qty: number): number {
    const { unitPrice, packSize } = this.getPriceDetails(basketRow);
    let pricePerQty = unitPrice * packSize;
    let newRowPriceInVat = pricePerQty * qty;

    return newRowPriceInVat;
  }

  static updateAndFormatPrice(input: string, newPrice: number, locale: string): string {
    const regex = /^(\D*)(\s?)([\d,.,\s]+?)(\s?)(\D*)$/;

    const match = input.match(regex);
    if (!match) {
      console.log('Invalid price format');
      return input;
    }

    // eslint-disable-next-line
    const [_, prefixSymbol, spaceBefore, originalPrice, spaceAfter, suffixSymbol] = match;

    // Use the provided locale to format the price
    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    const formattedPrice = formatter.format(newPrice);

    // Reassemble based on symbol placement
    if (suffixSymbol) {
      return `${formattedPrice}${spaceAfter}${suffixSymbol}`; // Add space after the price if it exists
    } else {
      return `${prefixSymbol}${spaceBefore}${formattedPrice}`; // Retain space before price if it exists
    }
  }

  private static parseCurrencyToFloat = (currencyString: string | null): number => {
    if (currencyString === null) return 0;
    const numericPart = currencyString.replace(/[^\d,.-]/g, '').replace(',', '.');
    return parseFloat(numericPart);
  };
}
